export default __webpack_public_path__ + "static/media/Hair_6_M_C4.48e26165.svg";